import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

const endpoint: string = environment.apiUrl;

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

interface ModulePermission { 
  id: string,
  name: string,
  email: string,
  is_viewer: boolean,
  is_editor: boolean,
};

@Injectable({
  providedIn: 'root',
})

export class ModulePermissionService {
  private http = inject(HttpClient);
  
  getCompanyUsers(moduleIdentifier: number): Observable<ModulePermission> {
    return this.http.get<ModulePermission>(`${endpoint}/api/module_permission/${moduleIdentifier}/users`, httpOptions);
  }

  getUsersByModulePermission(moduleIdentifier: number, isEditor : boolean): Observable<any> {
    return this.http.post<any>(`${endpoint}/api/module_permission/${moduleIdentifier}/viewers`, {isEditor : isEditor}, httpOptions);
  }

  togglePermission(userId: number, moduleIdentifier:number, field: string): Observable<{ success: boolean }> {
    return this.http.put<{ success: boolean }>(`${endpoint}/api/module_permission/${moduleIdentifier}/toggle`, { userId, field }, httpOptions);
  }

  hasViewerPermission(moduleIdentifier: number): Observable<{ hasPermission: boolean }> {
    return this.http.get<{ hasPermission: boolean }>(`${endpoint}/api/module_permission/${moduleIdentifier}/hasViewerPermission`, httpOptions);
  }

  hasEditorPermission(moduleIdentifier: number): Observable<{ hasPermission: boolean }> {
    return this.http.get<{ hasPermission: boolean }>(`${endpoint}/api/module_permission/${moduleIdentifier}/hasEditorPermission`, httpOptions);
  }

  getViewerPermissions(): Observable<any> {
    return this.http.get<any>(`${endpoint}/api/module_permission/getViewerPermissions`, httpOptions);
  }
}